export const COLOUR = "COLOUR"
export const GENDER = "GENDER"
export const PRICE = "PRICE"
export const TYPE = "TYPE"
export const CLEAR_FILTERS = "CLEAR_FILTERS"